import { motion } from 'framer-motion';
import { AuroraBlobs, GrainOverlay, GlassChip, Reveal, fadeUp, stagger } from '../components/ui';
import { LegalPage } from './TermsPage';

const SECTIONS = [
  { title: 'Eligible Items', body: 'Items can be returned within 7 days of delivery if they are unworn, unwashed, and in original packaging with all tags attached. Sale items marked "Final Sale" are not eligible for return.' },
  { title: 'Non-Returnable Items', body: 'Items that have been worn, washed, or damaged by the customer. Items without original tags or packaging. Items purchased during clearance sales marked as non-returnable.' },
  { title: 'How to Initiate a Return', body: 'Go to My Orders → Select the order → Click "Request Return" → Select the reason → Submit. Our team will review and approve within 24 hours. Once approved, a pickup will be scheduled.' },
  { title: 'Refund Process', body: 'Refunds are issued to the original payment method within 7–10 business days of the returned item being received and inspected. COD orders receive refunds via bank transfer (NEFT/IMPS).' },
  { title: 'Exchanges', body: 'We currently do not offer direct exchanges. To get a different size or colour, initiate a return for a refund and place a new order.' },
  { title: 'Damaged or Wrong Items', body: 'If you received a damaged or incorrect item, please contact us within 48 hours of delivery with photos at support@vritiethnic.in. We will arrange a replacement or full refund at no charge.' },
  { title: 'Contact', body: 'For return-related questions, email support@vritiethnic.in or call our support line Monday–Saturday, 10am–6pm IST.' },
];

const SUMMARY = [
  { label: 'Return window', value: '7 days', sub: 'after delivery' },
  { label: 'Refund timeline', value: '7–10 days', sub: 'to original payment' },
  { label: 'Pickup', value: 'Free', sub: 'at your doorstep' },
];

export default function ReturnsPage() {
  return (
    <div>
      <section style={{ position: 'relative', background: '#1A100E', overflow: 'hidden', padding: '64px 24px 56px' }}>
        <AuroraBlobs muted />
        <GrainOverlay />
        <div style={{ position: 'relative', zIndex: 2, maxWidth: 880, margin: '0 auto' }}>
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <GlassChip>Hassle-free</GlassChip>
          </motion.div>
          <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }} className="serif" style={{ fontSize: 'clamp(36px, 4.6vw, 56px)', color: '#FFF', lineHeight: 1.05, letterSpacing: '-0.02em', marginTop: 18, marginBottom: 10 }}>
            Returns & Refunds
          </motion.h1>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.25 }} style={{ fontSize: 12, color: 'rgba(237,227,209,0.5)', letterSpacing: '0.14em', textTransform: 'uppercase' }}>
            Last updated: June 2025
          </motion.div>

          {/* Quick summary glass tiles */}
          <motion.div variants={stagger} initial="hidden" animate="show" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginTop: 36 }} className="returns-summary">
            {SUMMARY.map(s => (
              <motion.div key={s.label} variants={fadeUp} style={{
                padding: '20px 18px',
                background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(237,227,209,0.16)', borderRadius: 18,
                backdropFilter: 'blur(20px) saturate(160%)', WebkitBackdropFilter: 'blur(20px) saturate(160%)',
                textAlign: 'center',
              }}>
                <div className="serif" style={{ fontSize: 28, color: '#E9C77A', lineHeight: 1, marginBottom: 6, letterSpacing: '-0.01em' }}>{s.value}</div>
                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(237,227,209,0.5)' }}>{s.label}</div>
                <div style={{ fontSize: 11, color: 'rgba(237,227,209,0.6)', marginTop: 4 }}>{s.sub}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <div style={{ maxWidth: 760, margin: '0 auto', padding: '40px 24px 64px' }}>
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-40px' }} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {SECTIONS.map(s => (
            <motion.div key={s.title} variants={fadeUp} className="ve-glass-form-card" style={{ padding: '22px 26px' }}>
              <h2 className="serif" style={{ fontSize: 21, marginBottom: 10, color: 'var(--ink)', letterSpacing: '-0.01em' }}>{s.title}</h2>
              <p style={{ lineHeight: 1.8, color: 'var(--ink-2)', fontSize: 14 }}>{s.body}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>

      <style>{`
        @media (max-width: 700px) {
          .returns-summary { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}
